import React from 'react';
import { Modal } from 'react-bootstrap';
import Image from '@ecs/tng-common/src/components/image/Image';
import { sharedAssetsPath } from '@ecs/tng-common/src/scripts/data';
import { Link } from 'gatsby';
import { categoryBasePath } from '../content/card-category-pages';

type NoLoansProps = {
  suppressed: boolean;
};
type NoLoansState = {
  show: boolean;
};
class CardsSuppressedModal extends React.Component<NoLoansProps, NoLoansState> {
  constructor(props: NoLoansProps) {
    super(props);
    this.state = { show: false };
  }

  componentDidMount() {
    this.setState(() => ({
      show: this.props.suppressed
    }));
  }

  render() {
    return (
      <Modal
        show={this.state.show}
        fullscreen="sm-down"
        aria-labelledby="modal-title"
        className="text-center">
        <Modal.Body>
          <Image
            className="mb-4"
            alt="Stacked credit cards."
            src={`${sharedAssetsPath}/icons/icon-credit-card.svg`}
            width="120"
            height="120"
          />
          <h2
            id="modal-title"
            className="h4">
            This card is not currently available
          </h2>
          <p className="mb-4 text-gray">
            Instead, get personalized recommendations based on your unique credit profile.
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Link
            className="btn btn-secondary"
            to={categoryBasePath}>
            Get started for free
          </Link>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default CardsSuppressedModal;
